"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var FirstPage_1 = __importDefault(require("@material-ui/icons/FirstPage"));
var KeyboardArrowLeft_1 = __importDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = __importDefault(require("@material-ui/icons/KeyboardArrowRight"));
var LastPage_1 = __importDefault(require("@material-ui/icons/LastPage"));
require("./TransactionTable.css");
function TablePaginationActions(props) {
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onChangePage = props.onChangePage;
    var totalNumPages = Math.ceil(count / rowsPerPage);
    var handleFirstPageClick = function (event) {
        onChangePage(event, 0);
    };
    var handleBackClick = function (event) {
        onChangePage(event, page - 1);
    };
    var handleNextClick = function (event) {
        onChangePage(event, page + 1);
    };
    var handleLastPageClick = function (event) {
        onChangePage(event, totalNumPages - 1);
    };
    var handleSinglePageClick = function (event, pageNumber) {
        onChangePage(event, pageNumber);
    };
    // Handles the paginator being zero-based (0,1,2...) but the display needed to start w/ 1 (1,2,3...)
    var calcPaginatorPages = function (totalNumPages, currentPage) {
        var MAX_PAGES_PER = 5;
        var pages;
        if (totalNumPages > MAX_PAGES_PER) {
            if (currentPage < MAX_PAGES_PER) {
                pages = Array.from(Array(MAX_PAGES_PER), function (_, i) { return i + 1; });
            }
            else if (totalNumPages === currentPage) {
                pages = [currentPage - 4, currentPage - 3, currentPage - 2, currentPage - 1, currentPage];
            }
            else {
                pages = [currentPage - 3, currentPage - 2, currentPage - 1, currentPage, currentPage + 1];
            }
        }
        else {
            pages = Array.from(Array(totalNumPages), function (_, i) { return i + 1; });
        }
        return pages;
    };
    return (react_1.default.createElement("div", { className: "table-pagination" },
        react_1.default.createElement(Button_1.default, { onClick: handleFirstPageClick, disabled: page === 0, "aria-label": "first page" },
            react_1.default.createElement(FirstPage_1.default, null)),
        react_1.default.createElement(Button_1.default, { onClick: handleBackClick, disabled: page === 0, "aria-label": "previous page" },
            react_1.default.createElement(KeyboardArrowLeft_1.default, null)),
        totalNumPages !== 0
            ? calcPaginatorPages(totalNumPages, page).map(function (pageIndex) { return (react_1.default.createElement(Button_1.default, { "aria-label": "single page selector", key: pageIndex, onClick: function (e) { return handleSinglePageClick(e, pageIndex - 1); }, className: pageIndex === page + 1 ? 'pagination-single active-page' : 'pagination-single', disabled: pageIndex === page + 1 }, pageIndex)); })
            : null,
        react_1.default.createElement(Button_1.default, { onClick: handleNextClick, disabled: page === totalNumPages - 1, "aria-label": "next page" },
            react_1.default.createElement(KeyboardArrowRight_1.default, null)),
        react_1.default.createElement(Button_1.default, { onClick: handleLastPageClick, disabled: page === totalNumPages - 1, "aria-label": "last page" },
            react_1.default.createElement(LastPage_1.default, null))));
}
exports.default = TablePaginationActions;
